// Genesis Utilities
import ParameterValidator from '@mvps-genesis/parameter-validator';

export default class InputPasswordRequirementSetting {

	/**
	 * The form element being validated.
	 *
	 * @var	@mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 *
	 * @var	Object
	 * @property String message Sentance of what the password requirement per setting
	 * @property String pattern Regular expression for the password requirement per setting
	 */
	requirement;

	/**
	 * @var	HTMLDivElement Reference to the requirement setting element
	 */
	element;

	/**
	 * Constructor of `InputPasswordRequirementSetting`
	 * @param  {Object} requirement
	 */
	constructor (requirement) {
		this.#validator = new ParameterValidator(this);
		this.requirement = this.#validator.isObject('requirement', requirement);
		this.element = this.#validator.isElement('element', this.createSettingElement());
	}

	/**
	 * Sets the `valid` state of the setting
	 * @return {undefined}
	 */
	valid () {
		const settingElement = this.element.firstElementChild;
		settingElement.classList.add('g-form-password-requirements__icon--valid');
		settingElement.classList.remove('u-icon-cross');
		settingElement.classList.add('u-icon-check');
	}

	/**
	 * Sets the `invalid` state of the setting
	 * @return {undefined}
	 */
	invalid () {
		const settingElement = this.element.firstElementChild;
		settingElement.classList.remove('g-form-password-requirements__icon--valid');
		settingElement.classList.remove('u-icon-check');
		settingElement.classList.add('u-icon-cross');
	}

	/**
	 * Creates the setting DOM element based off the `passwordSettings` property
	 * @return {HTMLDivElement}
	 */
	createSettingElement () {
		const settingFragment = document.createRange().createContextualFragment(`<div class="g-form-password-requirements__item"><span class="g-form-password-requirements__icon u-icon-cross"></span><span class="g-form-password-requirements__message">${this.requirement.message}</span></div>`);

		return settingFragment.firstChild ? settingFragment.firstChild : settingFragment.firstElementChild;
	}
}
